import React from "react";
import { Table } from "antd";
import { formatNumberWithCommas } from "../../helpers/formatters";

const columns = [
  {
    title: "Company",
    dataIndex: "company",
    key: "company",
    filterSearch: true, // Enables the search box within the filter dropdown
    onFilter: (value, record) =>
      record.company.toString().toLowerCase().includes(value.toLowerCase()),
    sorter: (a, b) => a.company.localeCompare(b.company),
    render: (text) => text?.toUpperCase(),
  },
  {
    title: "User",
    dataIndex: "username",
    key: "username",
    filterMode: "tree",
    filterSearch: true,
    onFilter: (value, record) =>
      record.username.toString().toLowerCase().includes(value.toLowerCase()),
    sorter: (a, b) => a.username.localeCompare(b.username),
  },
  {
    title: "Source",
    dataIndex: "source",
    key: "source",
    sorter: (a, b) => a.source.localeCompare(b.source),
    render: (text) => text?.toUpperCase(),
  },
  {
    title: "Product",
    dataIndex: "product",
    key: "product",
    sorter: (a, b) => (a, b) => a.product.localeCompare(b.product),
    render: (text) => text?.toUpperCase(),
  },
  {
    title: "Total Orders",
    dataIndex: "call_count",
    key: "call_count",
    render: (text) => formatNumberWithCommas(text),
    sorter: (a, b) => a.call_count - b.call_count,
  },
  {
    title: "Success",
    dataIndex: "success_count",
    key: "success_count",
    render: (text) => formatNumberWithCommas(text),
    sorter: (a, b) => a.success_count - b.success_count,
  },
  {
    title: "Failure",
    dataIndex: "failure_count",
    key: "failure_count",
    render: (text) => formatNumberWithCommas(text),
    sorter: (a, b) => a.failure_count - b.failure_count,
  },
  {
    title: "ValProPDF Success Count",
    dataIndex: "valpro_pdf_success_count",
    key: "valpro_pdf_success_count",
    render: (text) => formatNumberWithCommas(text),
    sorter: (a, b) => a.valpro_pdf_success_count - b.valpro_pdf_success_count,
  },
  {
    title: "ValProPDF Failure Count",
    dataIndex: "valpro_pdf_fail_count",
    key: "valpro_pdf_fail_count",
    render: (text) => formatNumberWithCommas(text),
    sorter: (a, b) => a.valpro_pdf_fail_count - b.valpro_pdf_fail_count,
  },
  {
    title: "Success Rate (%)",
    key: "success_rate",
    render: (text, record) => {
      const rate =
        record.call_count > 0
          ? ((record.success_count / record.call_count) * 100).toFixed(2)
          : 0;
      return `${rate}%`;
    },
  },
  {
    title: "Failure Rate (%)",
    key: "failure_rate",
    render: (text, record) => {
      const rate =
        record.call_count > 0
          ? ((record.failure_count / record.call_count) * 100).toFixed(2)
          : 0;
      return `${rate}%`;
    },
  },
];

const OrdersByUserTable = ({ data }) => {
  const dataWithKeyINdex = data.map((item, index) => ({ ...item, key: index }));
  return (
    <Table
      dataSource={dataWithKeyINdex}
      columns={columns}
      rowKey="key"
      pagination={{
        pageSize: 10, // Number of rows per page
        showSizeChanger: true, // Allows user to change page size
        pageSizeOptions: ["10", "20", "50"], // Options for rows per page
      }}
      scroll={{ x: "max-content" }} // Enables horizontal scroll for smaller screens
    />
  );
};

export default OrdersByUserTable;
